export function getLink(collectionKey: string, name: string): string {
    return `/${collectionKey}/${name.toLowerCase().replace(/ /g, '')}`
}